

import { Vue, Component } from 'vue-property-decorator'
import { KeepAlive } from '@/utils/decorators'
import Add from './Add.vue'
import Detail from './Detail.vue'
import Head from '../Head.vue'
@Component({
  components: { Add, Detail, Head },
  filters: {
    maintainState (val: any) {
      if (val === '2') {
        return '维保中'
      } else if (val === '3') {
        return '待确认'
      } else if (val === '4') {
        return '已完成'
      } else if (val === '5') {
        return '已关闭'
      }
    }
  }
})
@KeepAlive
export default class InsectPest extends Vue {
  private addShow = false
  private detailShow = false
  // private endShow = false
  private headShow = false
  private goWhere = '' // true 确认保养，end 结束保养
  private maintainId = ''
  private auth = false
  private maintainTime = [] // 保养时间
  private searchInfo = {
    machineryName: '', // 机械名称
    maintenanceNameCode: '', // 保养单编号/保养人
    startDate: '', // 保养时间开始
    endDate: '', // 保养时间结束
    maintenanceState: '' // 保养单状态1待开始2待维修3待确认4结束5关闭
  }

  private maintainStateList = [
    {
      value: '2',
      label: '维保中'
    },
    {
      value: '3',
      label: '待确认'
    },
    {
      value: '4',
      label: '已完成'
    },
    {
      value: '5',
      label: '已关闭'
    }
  ]

  private loading = false
  private tableData = []
  private total = 0
  private page = 1
  private size = 10
  private personList = []

  get maintainIdQuery () {
    return this.$route.query.maintainId as string || ''
  }

  get userId () {
    return this.$store.state.userInfo.userId
  }

  created () {
    this.getHeadList()
    // 机械详情的保养列表查看详情
    if (this.maintainIdQuery) {
      this.detailShow = true
      this.maintainId = this.maintainIdQuery
    }
    this.loadData()
    // 如果有 machineryId 则是从归还领用过来的, 打开新增弹窗
    if (this.$route.query.machineryId) {
      this.addShow = true
    }
  }

  loadData () {
    // this.goWhere = ''
    this.loading = true
    this.$axios.get(this.$apis.machineryManage.selectYhMachineryMaintenanceByPage,
      {
        ...this.searchInfo,
        page: this.page,
        size: this.size
      }).then(res => {
      this.tableData = res.list || []
      this.tableData.forEach((item: any) => {
        item.auth = this.getAuth(item.projectId)
      })
      this.total = res.total || 0
    }).finally(() => {
      this.loading = false
    })
  }

  onSearch () {
    this.page = 1
    this.loadData()
  }

  // 去新增页面
  onAdd () {
    this.addShow = true
  }

  onDetail (item: any) {
    this.detailShow = true
    this.maintainId = item.maintainId
    this.auth = item.auth
  }

  onEnd (maintainId: any) {
    // console.log('确认')
    this.maintainId = maintainId
    this.detailShow = true
    this.goWhere = 'end'
  }

  onTrue (maintainId: any) {
    // console.log('列表页this.goWhere', this.goWhere)
    // console.log('确认')
    this.maintainId = maintainId
    this.detailShow = true
    this.goWhere = 'true'
  }

  onHead () {
    this.headShow = true
  }

  success () {
    this.getHeadList()
    this.loadData()
  }

  onDelete (id: any) {
    this.$confirm('确认删除吗, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.$axios.post(this.$apis.machineryManage.deleteYhMachineryMaintenance, { maintainId: id }).then(() => {
        // console.log('开始保养成功', res)
        this.$message.success('删除成功')
        this.loadData()
        // this.formData = res || {}
      })
    })
  }

  selectTime1 (val: any) {
    // console.log('时间', val)
    if (!val) {
      this.searchInfo.startDate = ''
      this.searchInfo.endDate = ''
    } else {
      this.searchInfo.startDate = this.maintainTime[0]
      this.searchInfo.endDate = this.maintainTime[1]
    }
  }

  getAuth (id: string) {
    const item: any = this.personList.filter((item: any) => item.projectId === id)
    if (item[0]) {
      return item[0].userId === this.userId
    }
    return false
  }

  getHeadList () {
    this.$axios.get(this.$apis.machineryManage.selectYhMaintenanceUserByList).then(res => {
      this.personList = res.list || []
    })
  }
}
